export default "__VITE_ASSET__CDsyO5pO__"